import { Phone, Headphones, BarChart3, Shield, Cloud, Smartphone } from "lucide-react";

export default function VoIPFeatures() {
    const features = [
        {
            icon: Phone,
            title: "Crystal Clear Calls",
            description: "HD voice quality ensures every conversation is clear and professional, making great impressions with every call."
        },
        {
            icon: Headphones,
            title: "24/7 Support",
            description: "Round-the-clock customer support to ensure your business communication never stops working."
        },
        {
            icon: BarChart3,
            title: "Advanced Analytics",
            description: "Detailed call analytics and reporting to help you understand and optimize your business communications."
        },
        {
            icon: Shield,
            title: "Enterprise Security",
            description: "Bank-level encryption and security protocols to keep your business conversations completely private."
        },
        {
            icon: Cloud,
            title: "Cloud-Based System",
            description: "Access your phone system from anywhere, on any device. No hardware installation required."
        },
        {
            icon: Smartphone,
            title: "Mobile Apps",
            description: "Stay connected on the go with our mobile apps for iOS and Android. Your business line in your pocket."
        }
    ];

    return (
        <section className="py-16 lg:py-24 relative overflow-hidden bg-gradient-to-b from-purple-900/5 to-transparent">
            <div className="container">
                {/* Header */}
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
                        Features
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        Enterprise AI-powered phone system
                    </h2>
                    <p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
                        Everything your business needs for professional communication
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div key={index} className="group">
                                <div className="h-full bg-gradient-to-br from-purple-600/5 to-blue-600/5 rounded-2xl p-8 border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300">
                                    {/* Icon */}
                                    <div className="w-14 h-14 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <Icon className="w-7 h-7 text-white" strokeWidth={2} />
                                    </div>

                                    {/* Content */}
                                    <h3 className="text-xl font-bold text-white mb-3">
                                        {feature.title}
                                    </h3>
                                    <p className="text-gray-300 text-base leading-relaxed">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}